import React from "react";
import {
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Stack,
  Typography,
} from "@mui/material";

const CLOUD_MATURITY_DESCRIPTION =
  "Provides a breakout of the products flagged as Cloud vs Non-Cloud and percentage of cloud products for each company. There are two focus segments: current tech stack (products verified in the last 24 months) and new products added in the last 18 months. The Delta column indicates the percent change in cloud maturity from the all time tech stack to the products added in the last 18 months.";

interface Props {
  isCloudMaturityEnabled: boolean;
  setIsCloudMaturityEnabled: (flag: boolean) => void;
}

export const CloudMaturityOptions: React.FC<Props> = ({
  isCloudMaturityEnabled,
  setIsCloudMaturityEnabled,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsCloudMaturityEnabled(event.target.value === "yes");
  };

  return (
    <Box sx={{ p: 3, width: "70%" }}>
      <Stack spacing={3}>
        <Typography variant="h6" component="h2">
          Cloud Maturity Analysis
        </Typography>

        <Typography variant="body2" color="text.secondary">
          {CLOUD_MATURITY_DESCRIPTION}
        </Typography>

        <FormControl component="fieldset">
          <Typography variant="subtitle2" sx={{ mb: 1 }}>
            Include Cloud Maturity Analysis?
          </Typography>
          <RadioGroup
            value={isCloudMaturityEnabled ? "yes" : "no"}
            onChange={handleChange}
            name="cloud-maturity-enabled"
          >
            <FormControlLabel value="yes" control={<Radio />} label="Yes" />
            <FormControlLabel value="no" control={<Radio />} label="No" />
          </RadioGroup>
        </FormControl>
      </Stack>
    </Box>
  );
};
